import { render, staticRenderFns } from "./bindGoods.vue?vue&type=template&id=27b36158&scoped=true&"
import script from "./bindGoods.vue?vue&type=script&lang=js&"
export * from "./bindGoods.vue?vue&type=script&lang=js&"
import style0 from "./bindGoods.vue?vue&type=style&index=0&id=27b36158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b36158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b36158')) {
      api.createRecord('27b36158', component.options)
    } else {
      api.reload('27b36158', component.options)
    }
    module.hot.accept("./bindGoods.vue?vue&type=template&id=27b36158&scoped=true&", function () {
      api.rerender('27b36158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customParameter/bindGoods.vue"
export default component.exports